/* src/app/@framework/components/SearchModal/SearchModal.component.less */
zapp-searchmodal .zapp-modal {
  width: 960px;
}
zapp-searchmodal zappicon > i {
  padding: 0 !important;
}
zapp-searchmodal .p-tabview-panels {
  height: 400px;
  overflow-y: auto;
}
zapp-searchmodal .search-result-row {
  cursor: pointer;
}
zapp-searchmodal .search-indexes-checkboxes {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 1rem;
  margin-bottom: 1rem;
}
zapp-searchmodal .search-box {
  margin-bottom: 1rem;
}
zapp-searchmodal .nothing-to-show-label {
  display: block;
  text-align: center;
}
zapp-searchmodal .clickable-icon {
  cursor: pointer;
}
/*# sourceMappingURL=SearchModal.component.css.map */
